import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import Image from 'next/image'

import type { BenefitAPI } from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'

import * as styles from './benefit-card.styles'

type BenefitCardProps = {
  affiliate?: boolean
}

const DATE_OFFSET = 2

export const BenefitCard = ({
  description,
  name,
  cashback_from: cashbackFrom,
  cashback_to: cashbackTo,
  date_until: deadline,
  type_suffix: typeSuffix,
  eshop,
  affiliate,
}: BenefitAPI & BenefitCardProps) => {
  const { staticTexts, origin } = useAdditionalData()
  const upToLabel = staticTexts?.affiliateBenefitUpTo
  const benefitItemLogo = eshop.logo || ''

  const logo = affiliate ? benefitItemLogo : `${origin}/static/${eshop.logo}`

  const date = new Date(deadline)
  const day = String(date.getDate()).padStart(DATE_OFFSET, '0')
  const month = String(date.getMonth() + 1).padStart(DATE_OFFSET, '0')
  const year = date.getFullYear()
  const formattedDate = `${day}. ${month}. ${year}`

  const formatLabel = (value: string) => (
    <span>
      {upToLabel} {Number(value).toFixed(1)} <span>{typeSuffix}</span>
    </span>
  )

  return (
    <div css={styles.card}>
      <div css={styles.logo}>
        <Image
          unoptimized
          alt="Eshop Logo"
          height={58}
          src={logo}
          width={230}
        />
      </div>

      {affiliate ? (
        <div css={styles.content}>
          {cashbackTo &&
          cashbackFrom &&
          +cashbackFrom > 0 &&
          cashbackFrom === cashbackTo ? (
            <Typography>
              {Number(cashbackTo).toFixed(1)} <span>{typeSuffix}</span>
            </Typography>
          ) : cashbackTo ? (
            <Typography css={styles.title} variant="h3">
              <span css={styles.secondary}>{formatLabel(cashbackTo)}</span>
            </Typography>
          ) : cashbackFrom && +cashbackFrom > 0 ? (
            <Typography>{formatLabel(cashbackFrom)}</Typography>
          ) : null}

          <Typography>{name}</Typography>
        </div>
      ) : (
        <div css={styles.content}>
          <span css={styles.badge} />
          <Typography css={styles.title} variant="h3">
            {description || name}
          </Typography>
          <Typography>{formattedDate}</Typography>
        </div>
      )}
    </div>
  )
}
